import styled from 'styled-components';

export const ReviewMeta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 18px;
  color: rgba(0, 0, 0, 0.6);
`;
